import { IconFont, Text, Tooltip } from '@byecode/ui'
import { type SegmentedControlItem } from '@mantine/core'
import React from 'react'

export const BUTTON_SHAPE_OPTIONS = [
    {
        label: (
            <Tooltip title="矩形按钮">
                <IconFont size={16} color="var(--color-gray-500)" type="Rectangle" />
            </Tooltip>
        ),
        value: 'rectangle'
    },
    {
        label: (
            <Tooltip title="圆角按钮">
                <IconFont size={16} color="var(--color-gray-500)" type="Pill" />
            </Tooltip>
        ),
        value: 'round'
    }
]

export const BUTTON_RADIUS_OPTIONS = [
    {
        label: (
            <Tooltip title="无圆角">
                <IconFont size={16} color="var(--color-gray-500)" type="RadiusOne" />
            </Tooltip>
        ),
        value: '0'
    },
    {
        label: (
            <Tooltip title="较小圆角">
                <IconFont size={16} color="var(--color-gray-500)" type="RadiusTwo" />
            </Tooltip>
        ),
        value: '4'
    },
    {
        label: (
            <Tooltip title="标准圆角">
                <IconFont size={16} color="var(--color-gray-500)" type="RadiusThree" />
            </Tooltip>
        ),
        value: '8'
    },
    {
        label: (
            <Tooltip title="较大圆角">
                <IconFont size={16} color="var(--color-gray-500)" type="RadiusFour" />
            </Tooltip>
        ),
        value: '10'
    }
]

export const BUTTON_SIZE_OPTIONS = [
    {
        label: (
            <Tooltip title="最大">
                <Text>XXL</Text>
            </Tooltip>
        ),
        value: 'xxl'
    },
    {
        label: (
            <Tooltip title="超大">
                <Text>XL</Text>
            </Tooltip>
        ),
        value: 'xl'
    },

    {
        label: (
            <Tooltip title="大">
                <Text>L</Text>
            </Tooltip>
        ),
        value: 'lg'
    },
    {
        label: (
            <Tooltip title="中">
                <Text>M</Text>
            </Tooltip>
        ),
        value: 'md'
    },
    {
        label: (
            <Tooltip title="小">
                <Text>S</Text>
            </Tooltip>
        ),
        value: 'sm'
    }
]

/** 位置选项 */
export const ICON_POSITION_CONTROL: SegmentedControlItem[] = [
    {
        label: '左',
        value: 'left'
    },
    {
        label: '右',
        value: 'right'
    }
]

/** 宽度规则 */
export const FIT_TYPE_CONTROL: SegmentedControlItem[] = [
    {
        label: (
            <Tooltip title="包住内容">
                <IconFont type="ArrowsInLineHorizontal" />
            </Tooltip>
        ),
        value: 'auto'
    },
    {
        label: (
            <Tooltip title="撑满容器">
                <IconFont type="ArrowsOutLineHorizontalContain" />
            </Tooltip>
        ),
        value: 'contain'
    }
]
